import React, { useEffect, useState } from 'react';
import {
  List,
  ListItem,
  Typography,
  FormControlLabel,
  FormControl,
  FormGroup,
  Switch,
} from '@material-ui/core';
import { toJS } from 'mobx';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';

const NotificationMgr = () => {
  const [preferences, setPreferences] = useState([
    {
      Category: 'Organization Setup',
      Push: false,
      Email: true,
      Desc: 'Detailed description goes here',
    },
    {
      Category: 'Invitations',
      Push: true,
      Email: true,
      Desc: 'Detailed description goes here',
    },
    {
      Category: 'Deal Status',
      Push: true,
      Email: false,
      Desc: 'Detailed description goes here',
    },
    {
      Category: 'Transaction Status',
      Push: true,
      Email: false,
      Desc: 'Detailed description goes here',
    },
  ]);
  const [loading, setLoading] = useState(true);

  const { authStore } = useRootStore();

  const { accountInfo } = authStore;

  const forSetup = val => val === 'Organization Setup';

  const { Name, NotificationPref } = accountInfo;
  useEffect(() => {
    if (NotificationPref) setPreferences(NotificationPref);
  }, [NotificationPref]);

  useEffect(() => {
    const getAccountInfo = async () => {
      await authStore.retrieveUser();
      setLoading(false);
    };
    getAccountInfo();
  }, []);

  if (loading) return <Spinner />;

  const updateUser = async () => {
    const pref = JSON.stringify(preferences);
    try {
      await authStore.request.post(`${process.env.REACT_APP_API}/api/user`, {
        name: Name,
        notificationPref: pref,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = index => event => {
    const newArr = [...preferences];

    const { name } = event.target;

    newArr[index][name] = !newArr[index][name];

    setPreferences(newArr);
    updateUser();
  };

  return (
    <div style={{ margin: '20px' }}>
      <Typography variant="h4">Notification Settings</Typography>

      <List>
        {preferences.map((pref, index) => {
          const { Category, Push, Email, Desc } = pref;

          return (
            <ListItem key={Category}>
              <div>
                <div>{Category}</div>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={forSetup(Category) ? false : Push}
                        onChange={handleChange(index)}
                        name="Push"
                        value={forSetup(Category) ? false : Push}
                        disabled={forSetup(Category)}
                      />
                    }
                    label="In App"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Email}
                        onChange={handleChange(index)}
                        name="Email"
                        value={Email}
                      />
                    }
                    label="Email"
                  />
                </FormGroup>
              </div>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default NotificationMgr;
